var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"content-footer text-muted"},[_c('div',{attrs:{"title":'Versio numero ' + _vm.version + ' käännetty ' + _vm.buildtime}},[_vm._v("Versio: "+_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }